import { render } from "./AppAdvantages.vue?vue&type=template&id=5abae918&scoped=true"
import script from "./AppAdvantages.vue?vue&type=script&lang=js"
export * from "./AppAdvantages.vue?vue&type=script&lang=js"

import "./AppAdvantages.vue?vue&type=style&index=0&id=5abae918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abae918"]])

export default __exports__